/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Organize_ListInputs */

const en_us2_plan_build_organize_list = /** @type {(inputs: Plan_Build_Organize_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The plan's workouts, in order`)
};

const pt_br2_plan_build_organize_list = /** @type {(inputs: Plan_Build_Organize_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinos do plano, na ordem`)
};

const es_419_plan_build_organize_list = /** @type {(inputs: Plan_Build_Organize_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los entrenamientos del plan, en orden`)
};

const pt_pt2_plan_build_organize_list = /** @type {(inputs: Plan_Build_Organize_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treinos do plano, por ordem`)
};

const fr_fr2_plan_build_organize_list = /** @type {(inputs: Plan_Build_Organize_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les séances du programme, dans l'ordre`)
};

const de_de2_plan_build_organize_list = /** @type {(inputs: Plan_Build_Organize_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Trainings des Plans, in Reihenfolge`)
};

const it_it2_plan_build_organize_list = /** @type {(inputs: Plan_Build_Organize_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gli allenamenti della scheda, in ordine`)
};

/**
* | output |
* | --- |
* | "The plan's workouts, in order" |
*
* @param {Plan_Build_Organize_ListInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_organize_list = /** @type {((inputs?: Plan_Build_Organize_ListInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Organize_ListInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_organize_list(inputs)
	if (locale === "es-419") return es_419_plan_build_organize_list(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_organize_list(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_organize_list(inputs)
	if (locale === "de-DE") return de_de2_plan_build_organize_list(inputs)
	if (locale === "it-IT") return it_it2_plan_build_organize_list(inputs)
	return en_us2_plan_build_organize_list(inputs)
});
export { plan_build_organize_list as "plan-build.organize_list" }